import { DateTime } from '@ksyos/date-time';

export function getMinReferenceDateTime(now: DateTime = DateTime.now()) {
    const isNowInFirstQuarter = now.month() < 3;
    const minYear = isNowInFirstQuarter ? now.year() - 1 : now.year();

    return DateTime.fromObject({ date: 1, month: 0, year: minYear });
}

export function getMaxReferenceDateTime(now: DateTime = DateTime.now()) {
    const nextQuarter = now.quarter() + 1;

    return DateTime.fromObject({ date: 1, month: 0, year: now.year() }).quarter(nextQuarter);
}
